export default "__VITE_ASSET__UYCN_p3E__"